const theme = {
  colors: {
    primary: '#158837',
    lightgray: '#eaeaea',
    darkgray: '#afafaf',
  },
  grid: {
    base: '1rem',
  },
};
export default theme;
